import style from './SenderReceiverBlock.css';
import useTranslation from '../../../localization/i18n.context';
import ArrowRightIcon from '../../shared/Icons/ArrowRightIcon';
import ContactIcon from '../../shared/Icons/ContactIcon';

export default function SenderReceiverBlock({
  className = '',
  sender,
  receiver,
  senderIcon,
  receiverIcon,
}) {
  const { t, getOrganization } = useTranslation();
  const title = sender.name ? '' : t('Card');
  const card = sender.name
    ? t(sender.name)
    : getOrganization(sender?.organizationCode);
  return (
    <div className={`${className} ${style.container}`}>
      <div className={style.from}>
        <div className={senderIcon ? style.fromIcon : ''}>{senderIcon}</div>
        <div className={style.fromContent}>
          <p className={style.fromTitle}>{title}</p>
          <p className={style.fromCard}>{card}</p>
        </div>
      </div>
      <div className={style.to}>
        <div className={receiverIcon ? style.toIcon : ''}>{receiverIcon}</div>

        <div className={style.toContent}>
          <p className={style.toTitle}>{receiver?.name}</p>
        </div>
      </div>
      <div className={style.arrow}>
        <ArrowRightIcon width={16} height={16} />{' '}
      </div>
    </div>
  );
}
